export const WIDTHS = {
  SMALL: 260,
  MEDIUM: 380,
  LARGE: 650,
} as const;
